import { ConfigFn } from '@config/types'

const config = (({ publication }) => {
  const isRomandie = publication === 'romandie'
  const projectId = isRomandie ? '43577' : '43892'
  const url = `https://api.beyondwords.io/v1/projects/${projectId}/player`
  return {
    projectId,
    sourceUrl: `${url}/by_source_id/`,
    contentUrl: `${url}/by_content_id/`,
    nonBlickPlusSubscriberContentId: 'bb3148ba-857b-4733-8197-a5c4ffe04877',
    informationLink: isRomandie
      ? 'https://www.blick.ch/fr/services/la-fabrick/blick-notre-ligne-editoriale-voici-comment-nous-pratiquons-le-journalisme-a-blick-id19734304.html'
      : 'https://www.blick.ch/id19711657.html',
  } as const
}) satisfies ConfigFn

export default config
